module.exports = __webpack_public_path__ + "static/17-cfad07b19b3f99742bf591c6028101fc.png";